import { HTTPClient } from "./Client";

const LeadApi = {

    async listarLeadsAsync() {
        const response = await HTTPClient.get(`/Lead/ObterTodosLeads`);
        return response.data;
    },

    async deletarLeadAsync(leadId) {
        const response = await HTTPClient.delete(`/Lead/DeletarLead/${leadId}`);
        return response.data;
    },

    async obterLeadPorIdAsync(leadId) {
        const response = await HTTPClient.get(`/Lead/ObterLeadPorId/${leadId}`);
        return response.data;
    },

    async ListarLeadsComPaginacaoAsync(pagina, nome, email, origem , perido) {

        const leadsComPaginacao = {
            Pagina: pagina,
            Nome: nome,
            Email: email,
            Origem: origem,
            Periodo: perido
        };

        const response = await HTTPClient.post(`/Lead/ListarLeadsComPaginacao`, leadsComPaginacao);

        return response.data;
    },
}

export default LeadApi;